import { createFileRoute } from "@tanstack/react-router";
import { NotesGrid } from "../components/NotesGrid";

export const Route = createFileRoute("/reminders")({
  component: () => <NotesGrid title="Reminders" filter={{ has_reminder: true }} />,
});
